import { all } from 'redux-saga/effects';

import profileSagas from './profile/saga';

export default function* rootSaga() {
  yield all([profileSagas()]);
}
